import React from 'react'
import AttachTagItemHeader from './AttachTagItemTable/AttachTagItemHeader'
import AttachTagItemRow from './AttachTagItemTable/AttachTagItemRow'

function AttachTagItemTable(props) {
    const {listAttachTagItem, loading, setType, setBrand, setUser} = props

    return (
        <div className="AttachTagItemTable">
            <table className="table table-borderless table-striped">
                <AttachTagItemHeader/>
                <tbody className="AttachTagItemRow">
                {
                    !!listAttachTagItem && listAttachTagItem.map((item, i) => {
                        const {products, ...barcode} = item
                        item = {
                            ...products,
                            barcode,
                        }
                        const key = `${item._id}_${i}`

                        return <AttachTagItemRow
                            key={key}
                            index={i}
                            item={item}
                            setType={setType}
                            setBrand={setBrand}
                            setUser={setUser}
                        />
                    })
                }
                {
                    !loading && (!listAttachTagItem || listAttachTagItem.length === 0) &&
                    <tr>
                        <td colSpan={7}>
                            No result
                        </td>
                    </tr>
                }
                </tbody>
            </table>
        </div>
    )
}

export default AttachTagItemTable
